import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import clsx from "clsx";
import {
  COLUMN_ITEM_CLASS,
  DRAG_HANDLE_CLASS,
  SORTABLE_ITEM_CLASS,
  TOGGLE_LABEL_CLASS,
  CHECKBOX_CLASS,
  TEST_ID_LIST_ITEM,
  TEST_ID_TOGGLE_PREFIX,
} from "./constants";
import { Grip } from "lucide-react";

/**
 * SortableColumn Component
 * Renders a draggable column item with visibility toggle
 * @param {string} id - Column identifier
 * @param {string} header - Column header text
 * @param {Object} column - Column object from table
 * @param {Function} saveOrderingConfig - Callback to save configuration
 */
const SortableColumn = ({ id, header, column, saveOrderingConfig }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const isVisible = column.getIsVisible();

  return (
    <div className={COLUMN_ITEM_CLASS}>
      <div
        data-testid={TEST_ID_LIST_ITEM}
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
      >
        <Grip size={10} className={DRAG_HANDLE_CLASS} />
      </div>
      <div
        style={style}
        {...attributes}
        className={clsx(SORTABLE_ITEM_CLASS, !isVisible && "line-through")}
      >
        <label className={TOGGLE_LABEL_CLASS}>
          <input
            data-testid={`${TEST_ID_TOGGLE_PREFIX}${id}`}
            type="checkbox"
            checked={isVisible}
            onChange={(e) => {
              const toggleVisibility = column.getToggleVisibilityHandler();
              toggleVisibility(e);
              saveOrderingConfig(id, !isVisible);
            }}
            className={CHECKBOX_CLASS}
          />
          <span className="cursor-pointer text-sm">{header}</span>
        </label>
      </div>
    </div>
  );
};

export default SortableColumn;
